import { AnalysisRequest, emptyRequest } from '@/modules/analysis/models/analysisRequest';

/* eslint-disable */
export interface StateAnalysis {
  newRequest: AnalysisRequest;
  analysisRequestsList: Array<AnalysisRequest>;
}

export class State implements StateAnalysis {
  newRequest = emptyRequest();
  analysisRequestsList = [];
}
